import type { HardwareCatalogItem, HardwareMaterialSelection } from '@/shared/api/types';
import { isMaterialSelectionSha } from './facade-material-selection';

/** Preserve canonical catalog identity. Physical compatibility remains the backend operation's decision. */
export function captureHardwareMaterialSelection(card: Pick<HardwareCatalogItem, 'id' | 'catalogId' | 'sourceReleaseSha' | 'rowSha256'>): HardwareMaterialSelection {
  if (!Number.isSafeInteger(card.catalogId) || card.catalogId <= 0 || card.catalogId !== card.id) throw new Error('HARDWARE_CATALOG_ID_REQUIRED');
  return requireHardwareMaterialSelection(card);
}

export function requireHardwareMaterialSelection(selection: HardwareMaterialSelection): HardwareMaterialSelection {
  if (!Number.isSafeInteger(selection.catalogId) || selection.catalogId <= 0) throw new Error('HARDWARE_CATALOG_ID_REQUIRED');
  if (!isMaterialSelectionSha(selection.sourceReleaseSha) || !isMaterialSelectionSha(selection.rowSha256)) throw new Error('MATERIAL_SELECTION_PROVENANCE_REQUIRED');
  return Object.freeze({ catalogId: selection.catalogId, sourceReleaseSha: selection.sourceReleaseSha, rowSha256: selection.rowSha256 });
}
